export const getCookieDomain = (): string => {
  const hostname = window.location.hostname;

  const isIPorLocal =
    hostname === "localhost" ||
    /^\d+\.\d+\.\d+\.\d+$/.test(hostname) ||
    /^\[.*:.*\]$/.test(hostname);
  if (isIPorLocal) {
    return hostname;
  }

  const parts = hostname.split(".");
  if (parts.length > 2) {
    return `.${parts.slice(-2).join(".")}`;
  }

  return `.${hostname}`;
};
